import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import Button from 'components/button/Button';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import useAppModal from 'hooks/useAppModal';
import useFetchProperties from '../../common/useFetchProperties';
import PropertiesTable from '../../common/propertiesTable/PropertiesTable';

const VIEW_PROTECTED_PROPERTIES_MODAL_ID = 'view-protected-properties-modal';

const ViewProtectedPropertiesModal = ({
  protectedPropertyUids,
}: {
  protectedPropertyUids: string[];
}) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();
  const { allProperties, isFetching } = useFetchProperties();

  const checkedProperties = useMemo(() => {
    return (
      allProperties?.filter((property) => {
        return protectedPropertyUids.includes(property.uid);
      }) ?? []
    );
  }, [allProperties, protectedPropertyUids]);

  const handleClose = () => {
    closeModal(VIEW_PROTECTED_PROPERTIES_MODAL_ID);
  };

  if (isFetching) {
    return <LoadingPlaceholder />;
  }

  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('pageScreenAndProtect.currentPage.viewPropertiesModal.title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <Trans
            i18nKey="pageScreenAndProtect.currentPage.viewPropertiesModal.description"
            components={{ br: <br /> }}
          />
        </p>
        <PropertiesTable properties={checkedProperties} />
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="primary" onClick={handleClose}>
          {t('common.close')}
        </Button>
      </Modal.Footer>
    </div>
  );
};

export { VIEW_PROTECTED_PROPERTIES_MODAL_ID };
export default ViewProtectedPropertiesModal;
